// Reviews Centre action types
// Reviews
export const GET_REVIEW_LIST = "GET_REVIEW_LIST";
export const GET_REVIEW_LIST_SUCCESS = "GET_REVIEW_LIST_SUCCESS";
export const GET_REVIEW_LIST_FAILURE = "GET_REVIEW_LIST_FAILURE";

export const GET_REVIEW_DATA = "GET_REVIEW_DATA";
export const GET_REVIEW_DATA_SUCCESS = "GET_REVIEW_DATA_SUCCESS";
export const GET_REVIEW_DATA_FAILURE = "GET_REVIEW_DATA_FAILURE";

export const CREATE_REVIEW = "CREATE_REVIEW";
export const CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS";
export const CREATE_REVIEW_FAILURE = "CREATE_REVIEW_FAILURE";

export const UPDATE_REVIEW = "UPDATE_REVIEW";
export const UPDATE_REVIEW_SUCCESS = "UPDATE_REVIEW_SUCCESS";
export const UPDATE_REVIEW_FAILURE = "UPDATE_REVIEW_FAILURE";

export const DELETE_REVIEW = "DELETE_REVIEW";
export const DELETE_REVIEW_SUCCESS = "DELETE_REVIEW_SUCCESS";
export const DELETE_REVIEW_FAILURE = "DELETE_REVIEW_FAILURE";

export const ASSIGN_REVIEW_CUSTOMER = "ASSIGN_REVIEW_CUSTOMER";
export const ASSIGN_REVIEW_CUSTOMER_SUCCESS = "ASSIGN_REVIEW_CUSTOMER_SUCCESS";
export const ASSIGN_REVIEW_CUSTOMER_FAILURE = "ASSIGN_REVIEW_CUSTOMER_FAILURE";

export const SET_REVIEW_STATUS = "SET_REVIEW_STATUS";
export const SET_REVIEW_STATUS_SUCCESS = "SET_REVIEW_STATUS_SUCCESS";
export const SET_REVIEW_STATUS_FAILURE = "SET_REVIEW_STATUS_FAILURE";

export const REPLY_REVIEW = "REPLY_REVIEW";
export const REPLY_REVIEW_SUCCESS = "REPLY_REVIEW_SUCCESS";
export const REPLY_REVIEW_FAILURE = "REPLY_REVIEW_FAILURE";

// Review Providers (connection config)
export const GET_REVIEW_PROVIDERS = "GET_REVIEW_PROVIDERS";
export const GET_REVIEW_PROVIDERS_SUCCESS = "GET_REVIEW_PROVIDERS_SUCCESS";
export const GET_REVIEW_PROVIDERS_FAILURE = "GET_REVIEW_PROVIDERS_FAILURE";

export const UPDATE_REVIEW_PROVIDER = "UPDATE_REVIEW_PROVIDER";
export const UPDATE_REVIEW_PROVIDER_SUCCESS = "UPDATE_REVIEW_PROVIDER_SUCCESS";
export const UPDATE_REVIEW_PROVIDER_FAILURE = "UPDATE_REVIEW_PROVIDER_FAILURE";

export const SYNC_REVIEW_GOOGLE = "SYNC_REVIEW_GOOGLE";
export const SYNC_REVIEW_GOOGLE_SUCCESS = "SYNC_REVIEW_GOOGLE_SUCCESS";
export const SYNC_REVIEW_GOOGLE_FAILURE = "SYNC_REVIEW_GOOGLE_FAILURE";

// Review Status lanes (admin lookup)
export const GET_REVIEW_STATUS_LIST = "GET_REVIEW_STATUS_LIST";
export const GET_REVIEW_STATUS_LIST_SUCCESS = "GET_REVIEW_STATUS_LIST_SUCCESS";
export const GET_REVIEW_STATUS_LIST_FAILURE = "GET_REVIEW_STATUS_LIST_FAILURE";

export const GET_REVIEW_STATUS_DATA = "GET_REVIEW_STATUS_DATA";
export const GET_REVIEW_STATUS_DATA_SUCCESS = "GET_REVIEW_STATUS_DATA_SUCCESS";
export const GET_REVIEW_STATUS_DATA_FAILURE = "GET_REVIEW_STATUS_DATA_FAILURE";

export const CREATE_REVIEW_STATUS = "CREATE_REVIEW_STATUS";
export const CREATE_REVIEW_STATUS_SUCCESS = "CREATE_REVIEW_STATUS_SUCCESS";
export const CREATE_REVIEW_STATUS_FAILURE = "CREATE_REVIEW_STATUS_FAILURE";

export const UPDATE_REVIEW_STATUS = "UPDATE_REVIEW_STATUS";
export const UPDATE_REVIEW_STATUS_SUCCESS = "UPDATE_REVIEW_STATUS_SUCCESS";
export const UPDATE_REVIEW_STATUS_FAILURE = "UPDATE_REVIEW_STATUS_FAILURE";

export const DELETE_REVIEW_STATUS = "DELETE_REVIEW_STATUS";
export const DELETE_REVIEW_STATUS_SUCCESS = "DELETE_REVIEW_STATUS_SUCCESS";
export const DELETE_REVIEW_STATUS_FAILURE = "DELETE_REVIEW_STATUS_FAILURE";
